import React, { useContext, useEffect, useState } from "react";
import { useScreenTransition } from "../Hooks/useScreenTransition";
import "./LogoAuthNavbar.css";
import { TransitionContext } from "../Context/TransitionContext";
import { useHistory } from "react-router-dom";
import { NotificationContext } from "../Context/NotificationContext";
import { AuthContext } from "../Context/AuthContext";
import { DataContext } from "../Context/DataContext";
import NewButton from "./NewButton";
import { auth } from "../firebase.config";
import NotificationModal from "./UserNotification/NotificationDropDown";
import { getNotificationIcon } from "../Data/notifications";
import useClientNotifications from "../Hooks/useFetchClientNotifications";
import { clearUserStats } from "../Data/notificationStatsQueue"

const LogoAuthNavbar = ({
  showButtons = true,
  accountPages = false,
  extraBreadLink = false,
  breadLink = null,
  breadLinkType,
  extraBreadLinkitem,
  extraBreadPath,
  admin = false,
}) => {

  const { transitionTo } = useScreenTransition();
  const [isAccountSignOutOpen, setIsAccountSignOutOpen] = useState(false);
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const { setBodyLock, setColor } = useContext(TransitionContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const history = useHistory();
  const { showNotification } = useContext(NotificationContext);
  const { clearSignOut, signedIn } = useContext(AuthContext);

  const [imgLoaded, setImgLoaded] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [refreshKeys, setRefreshKey] = useState(0);
  const notifications = useClientNotifications(userData ?? 'null', refreshKeys);
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    const hasUnreadNotifications = notifications.some(n => !n.readStatus?.isRead);
    setHasUnread(hasUnreadNotifications);
  }, [notifications]);

  useEffect(() => {
    if (signedIn && userData) {
      setProfilePicUrl(
        userData.profilePic && userData.profilePic.url
          ? userData.profilePic.url
          : auth.currentUser?.photoURL
      );
    } else {
      setProfilePicUrl(""); // Ensure we reset the state if user logs out
    }
  }, [signedIn, userData]);

  const signOut = () => {
    clearUserStats(userData?.id);    
    setColor(false);
    setBodyLock(false);
    history.push("/");

    auth.signOut()
      .then(() => {
        showNotification("Success", "You have signed out.", "success");
        clearSignOut();
      })
      .catch(() => {
        showNotification(
          "Error",
          "There was an error signing out. Please, try again.",
          "error"
        );
      });
  };

  const getFirstTwoLetters = () => {
    let twoLetters = "U";
    if (signedIn && userData) {
      if (userData.firstName) {
        twoLetters =
          userData.firstName[0] +
          (userData.lastName ? userData.lastName[0] : userData.firstName[1]);
      } else {
        twoLetters = userData.name ? userData.name.slice(0, 2) : "U";
      }
    }
    return twoLetters.toUpperCase();
  };

  const imgStyle =
    userData && userData.profilePic
      ? {
          transform: `scale(${userData.profilePic.scale})`,
          top: userData.profilePic.top,
          left: userData.profilePic.left,
          opacity: imgLoaded ? 1 : 0,
        }
      : {};

  const getBreadcrumbLabel = (type) => {
    switch (type) {
      case "order":
        return "Orders";
      case "invoice":
        return "Invoices";
      case "teams":
        return "Teams";
      default:
        return "Quotes";
    }
  };

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData && userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business", parsed: true })
      );
      setOrder((q) => ({ ...q, type: "business", parsed: true }));
    } else if (
      (signedIn && userData)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal", parsed: true })
      );
      setOrder((q) => ({ ...q, type: "personal", parsed: true }));
    }
  };

  return (
    <>
      <div className="logoAuthNavbarContainer select-none">
        <div className="logoAuthLogoWrap">
          <img
            src={require("../assets/logo.png")}
            alt="Logo eVerbary"
            className="authNavLogo"
            onClick={() => transitionTo("/?redirect=false")}
          />
        </div>
        <div
          className={`${
            breadLink
              ? "logoAuthNavWrap md:justify-between justify-end"
              : "logoAuthNavbarUserWrap"
          }`}
        >
          {breadLink && (
            <div className="logoAuthBreadText md:block hidden">
              {signedIn && userData && 
              <>
              <span
                className="logoAuthBreadLightText"
                onClick={(e) => {
                  transitionTo(
                    `${
                      breadLinkType === "teams"
                        ? "/office/teams"
                        : `/account/${
                            breadLinkType === "order"
                              ? "orders"
                              : breadLinkType === "invoice"
                              ? "invoices"
                              : "quotes"
                          }`
                    }`,
                    e
                  );
                }}
              >
                {getBreadcrumbLabel(breadLinkType)}
              </span>
              {extraBreadLink && (
                <>
                  <span className="mx-2">{" > "}</span>
                  <span
                    onClick={(e) => {
                      transitionTo(extraBreadPath, e);
                    }}
                  >
                    {" "}
                    {extraBreadLinkitem}{" "}
                  </span>
                </>
              )}
              <span className="mx-2">{">"}</span>
              <span>{breadLink}</span>
              </>}
            </div>
          )}

          <div className="logoAuthNavbarUserWrap">
            {showButtons && (
              admin ? <div className="logoAuthNavBarBtnWrap lg:flex hidden">
                <NewButton
                  text="Create Manually"
                  onClick={() => transitionTo("/manualQuote/create")}
                  width="150px"
                  back
                  icon={false}
                  whiteBtn
                />
              </div>
              :
              <div className="logoAuthNavBarBtnWrap lg:flex hidden">
                <NewButton
                  text="Create Order"
                  onClick={gotoOrder}
                  width="150px"
                />
                <NewButton
                  text="Free Quote"
                  onClick={(e) => transitionTo("/quote/details")}
                  back
                  icon={false}
                  whiteBtn
                  width="150px"
                />
              </div>
            )}

            {signedIn && userData && userData?.role === 'client' &&
              (
                <div
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={() => {
                    setOpenNotificationModal((prev) => !prev);
                    setRefreshKey(prev => prev + 1);
                  }}
                  className="cursor-pointer"
                >
                  {
                    React.createElement(
                      getNotificationIcon({
                        hasNotification : hasUnread,
                        open: openNotificationModal,
                        hovered: isHovered
                      })
                    )
                  }
                </div>
              )
            }
            {openNotificationModal &&
              <NotificationModal
                notifications={notifications}
                onClose={() => {
                  setOpenNotificationModal(false);
                  setTimeout(() => {
                    setRefreshKey(prev => prev + 1);
                  }, 300);
                }}
                userData={userData}
                setHasUnread={setHasUnread}
              />
            }
            {signedIn && userData && <div
              className="relative"
              onClick={() => setIsAccountSignOutOpen((i) => !i)}
            >
              <div className="logoAuthNavbarUser">
                {/* Handle profile picture correctly */}
                {(!profilePicUrl || !imgLoaded) && (
                  <div className="logoAuthNavbarUserName">
                    {getFirstTwoLetters()}
                  </div>
                )}
                {profilePicUrl && (
                  <img
                    className="accountMainProfileImg"
                    width={"100%"}
                    style={imgStyle}
                    onLoad={() => setImgLoaded(true)}
                    src={profilePicUrl}
                    alt="Profile"
                  />
                )}
              </div>

              {isAccountSignOutOpen && (
                <div className="logoAuthNavbarAccountSignOut">
                  {!accountPages && (
                    <div
                      className="logoAuthNavbarSignInSignOutOption"
                      onClick={() => transitionTo("/account/profile")}
                    >
                      {/* Account */}
                      Profile
                    </div>
                  )}
                  <div
                    className="logoAuthNavbarSignInSignOutOption"
                    onClick={() => signOut()}
                  >
                    Sign Out
                  </div>
                </div>
              )}
            </div>}
          </div>
        </div>
      </div>


      <div className={`w-full flex gap-4  ${extraBreadLink ?"sm:flex-col sm:justify-between" :"sm:flex-row  "}  flex-col  md:flex-end  justify-center items-center lg:hidden lg:p-0 pb-4`}>
        {signedIn && userData && breadLink && (
          <div className="logoAuthBreadText md:hidden block">
            <span
              className="logoAuthBreadLightText"
              onClick={(e) => {
                transitionTo(
                  `${
                    breadLinkType === "teams"
                      ? "/office/teams"
                      : `/account/${
                          breadLinkType === "order"
                            ? "orders"
                            : breadLinkType === "invoice"
                            ? "invoices"
                            : "quotes"
                        }`
                  }`,
                  e
                );
              }}
            >
              {getBreadcrumbLabel(breadLinkType)}
            </span>
            {extraBreadLink && (
              <>
                <span className=" md:mx-2 mx-[5px]">{" > "}</span>
                <span
                  onClick={(e) => {
                    transitionTo(extraBreadPath, e);
                  }}
                >
                  {" "}
                  {extraBreadLinkitem}{" "}
                </span>
              </>
            )}
            <span className="md:mx-2 mx-[5px]">{">"}</span>
            <span>{breadLink}</span>
          </div>
        )}

        {showButtons && (
          admin ?  
          <div className="logoAuthNavBarBtnWrap lg:hidden flex">
            <NewButton
              text="Create Manually"
              onClick={(e) => transitionTo("/manualQuote/create")}
              back
              icon={false}
              whiteBtn
              width="150px"
            />
          </div>
          :
          <div className="logoAuthNavBarBtnWrap lg:hidden flex">
            <NewButton text="Create Order" onClick={gotoOrder} width="150px" />
            <NewButton
              text="Free Quote"
              onClick={(e) => transitionTo("/quote/details")}
              back
              icon={false}
              whiteBtn
              width="150px"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LogoAuthNavbar;
